import styled from "styled-components";

export const FavoritePartnerItemsPanelStyled = styled.div`

`

export default FavoritePartnerItemsPanelStyled;